export default __webpack_public_path__ + "static/media/idea.ee11ded8.png";